import { EXPIRY_STATUS } from "@types";

export interface CopounHeaderProps {
  isHome?: boolean;
  canPurchaseAfterCoupon: boolean;
  expireDateFormatted: string;
  percentAfterCoupon: number;
  price: number;
  productName: string;
  courseCouponUrl: string;
  productId: string;
  closeBanner: () => void;
  isProfile?: boolean;
  expiryStatus?: EXPIRY_STATUS;
}

export enum COUPON_STATUS  {
  MORETHAN10="moreThan10" ,LESSTHAN10= "lessThan10" ,LESSTHAN24= "lessThan24"}
